import React, {useEffect, useState} from "react"
import {Link, useParams} from "react-router-dom"
import {Button} from "@chakra-ui/react"
import {Loading} from "@components/app"

import {BattleMode, Play, PlayCard} from "../components"
import {gamePlayApiCalls, GameStartType} from "../service"


type GameContainerProps = {}

export default function GameContainer({}: GameContainerProps) {
    const {gameId} = useParams()
    const [gamePlay, setGamePlay] = useState<GameStartType>()

    useEffect(() => {
        gamePlayApiCalls.start(gameId)
            .then((result) => {
                if (result.gamePlay?.voteData) {
                    console.log("before", result.gamePlay.voteData)
                    result.gamePlay.voteData = Object.keys(result.gamePlay.voteData)
                        .reduce((acc, qId) => {
                            const question = (result.game.modeOptions?.questionIds || []).find(x => x._id === qId)


                            acc[qId] = result.gamePlay.voteData[qId].map(vote => ({
                                ...vote,
                                voteId: vote._id,
                                questionId: question,
                                // @ts-ignore
                                labelId: (result.game.labelOptions?.setId?.labelIds || []).find((x) => x._id === vote.labelId)
                            }))
                            return acc
                        }, {})

                    console.log("after", result.gamePlay.voteData)
                }

                setGamePlay(result)
            })

    }, [])

    if (!gamePlay)
        return <Loading/>

    if (gamePlay.gamePlay.completeStatus === "finished")
        return <div>
            <PlayCard title="End Game">
                <Button colorScheme="blue" className="underline" variant="link" as={Link} to="/">
                    Go To Home Page
                </Button>
            </PlayCard>
        </div>

    if (gamePlay.game?.modeOptions.mode === "battle") {
        return <BattleMode {...gamePlay}/>
    }


    return <Play {...gamePlay}/>
}